import { z, array, literal, object, string, union, number, boolean } from "zod";

export type CommonModalProps = {
  onClose: () => void;
};

export const LadySliderModalMediaIntroVideo = object({
  type: literal("intro_video"),
  id: number().optional(),
  source: string().nullish(),
  isFavorite: boolean().optional(),
  static: string().nullish(),
  gif: string().nullish(),
});

export const LadySliderModalMediaVideo = object({
  type: literal("video"),
  id: number().optional(),
  source: string().nullish(),
  isFavorite: boolean().optional(),
  static: string().nullish(),
  gif: string().nullish(),
});

// TODO: possibly it should extend common photo from ladyV2DTO.
// Because this schema is used in slider parser in silent mode. And failed parse of this object will lead to the empty slider
// or to the slider with missing media
export const LadySliderModalMediaPhoto = object({
  mediaName: string().optional(),
  type: literal("photo"),
  photoType: string().optional(),
  photoId: number().optional(), // used in favorite request for auth user
  isFavorite: boolean().optional(),
  photoSrcs: object({
    small: string(),
    medium: string(),
    large: string(),
  }),
});

export const LadySliderModalMedia = array(
  union([
    LadySliderModalMediaIntroVideo,
    LadySliderModalMediaPhoto,
    LadySliderModalMediaVideo,
  ]),
);

export type LadySliderModalMediaIntroVideo = z.infer<
  typeof LadySliderModalMediaIntroVideo
>;
export type LadySliderModalMediaVideo = z.infer<
  typeof LadySliderModalMediaIntroVideo
>;
export type LadySliderModalMediaPhoto = z.infer<
  typeof LadySliderModalMediaPhoto
>;
export type LadySliderModalMedia = z.infer<typeof LadySliderModalMedia>;
